module.exports = __webpack_public_path__ + "87937ed1db6ad05efa2b833a86c273f3.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/imgs/People/ceo_Kristoffer_Karlsson_web.jpg
// module id = 159
// module chunks = 0